import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex top-container pb-6" }
const _hoisted_2 = { class: "flex pt-4" }

import { onMounted } from 'vue';
import { useRelayHubStore } from '@/store';
import OrganizationTable from './components/OrganizationTable.vue';
import StateTable from './components/StateTable.vue';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'RelayHub',
  setup(__props) {

const relayHubStore = useRelayHubStore();
const { data } = storeToRefs(relayHubStore);

const getConfig = async () => {
  await relayHubStore.fetchRelayHubConfig();
};

const getOrganizations = async () => {
  await relayHubStore.fetchOrganizations();
};

const getStates = async () => {
  await relayHubStore.fetchMedicaidEnabledStates();
};

const init = async () => {
  getConfig();
  await getStates();
  await getOrganizations();
};

onMounted(async () => {
  init();
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Card, { class: "mt-0 pt-0" }, {
    header: _withCtx(() => [
      _createElementVNode("h2", null, [
        _cache[0] || (_cache[0] = _createTextVNode(" RelayHub ", -1)),
        (_unref(data))
          ? _withDirectives((_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              name: "info",
              class: "text-primary-500 text-base cursor-pointer"
            }, null, 512)), [
              [
                _directive_tooltip,
                {
            value: `Host : ${_unref(data).host}:${_unref(data).port}`,
            escape: true,
            fitContent: true,
          },
                void 0,
                { bottom: true }
              ]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(StateTable, { onReset: init })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(OrganizationTable, { onReset: init })
      ])
    ]),
    _: 1
  }))
}
}

})